import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "image", "placeholder" ]

  connect() {
    if (!this.hasImageTarget) return

    this.addTransitionClasses()

    if (this.imageLoaded()) {
      this.showImage()
    } else {
      this.showPlaceholder()
      this.imageTarget.addEventListener("load", () => this.showImage(), { once: true })
      this.imageTarget.addEventListener("error", () => this.showPlaceholder(), { once: true })
    }
  }

  imageLoaded() {
    return this.imageTarget.complete && this.imageTarget.naturalWidth > 0
  }

  addTransitionClasses() {
    this.imageTarget.classList.add("transition-opacity", "duration-200")
  }

  showPlaceholder() {
    if (!this.hasPlaceholderTarget) return
    this.placeholderTarget.classList.remove("hidden", "opacity-0")
    this.imageTarget.classList.add("opacity-0")
  }

  showImage() {
    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.classList.add("opacity-0")
      window.setTimeout(() => {
        this.placeholderTarget.classList.add("hidden")
      }, 200)
    }
    this.imageTarget.classList.remove("opacity-0")
  }
}
